import React, {useEffect} from 'react'
import {Grid, Stack, CircularProgress, Skeleton} from '@mui/material'
import {CUSTOMER_TYPE} from '../../../utils/constants'
import pupilFilterApi from '../../../services/api/pupilFilters/pupilFilterApi'
import useCustomerData from '../../../hooks/useCustomerData'
import ParticipantList from '../../SurveyPanel/SurveyParticipants/ParticipantList'
import WbModal from '../../../components/common/WbModal'
import {getApiCallParams} from '../../../auth'
import {participantsApi} from '../../../services'
import {hasSelectedSchools} from '../checkInWizardRules'

export default function ShowParticipantList({
  count,
  setCount,
  participantFilter,
}) {
  const customer = useCustomerData()
  const [open, setOpen] = React.useState(false)
  const [showLoadCount, setShowLoadCount] = React.useState(false)
  const [pList, setPList] = React.useState([])
  const [loading, setLoading] = React.useState(false)
  const apiParams = getApiCallParams()

  const geColumnText = type => {
    switch (type) {
      case 'Current Year Grade':
        return 'CurrentYearGrade'
      case 'Special Education Needs Status':
        return 'SpecialEducationNeedsStatus'
      case 'Registration':
      case 'Gender':
        return type
      default:
        return ''
    }
  }

  const getFilterObject = () => {
    return {
      matId: apiParams.isMat ? apiParams.groupId : 0,
      schoolId: apiParams.isMat ? 0 : apiParams.schoolId,
      isStudentSurvey: true,
      isStaffSurvey: false,
      isParentSurvey: false,
      participationFilter: participantFilter,
    }
  }
  const updateCount = async () => {
    setShowLoadCount(true)

    var countFilter = getFilterObject()

    let c = await participantsApi.getStaffStudentParentCount(countFilter)
    if (c && JSON.parse(c).studentCount) {
      setCount(JSON.parse(c).studentCount)
      setShowLoadCount(false)
    } else {
      setCount(0)
      setShowLoadCount(false)
    }
  }

  useEffect(() => {
    if (hasSelectedSchools(participantFilter)) {
      updateCount()
    }
  }, [participantFilter])

  const handleOpen = async () => {
    setLoading(true)
    setOpen(true)
    let p = await participantsApi.getStudentByFilter(getFilterObject())
    setPList(p)
    setLoading(false)
  }

  return (
    <div className="participants">
      <div className="participant-card">
        <Grid container>
          <Grid item xs={12}>
            <Stack
              direction="row"
              justifyContent={'space-between'}
              alignItems={'flex-start'}
            >
              <div>
                <Stack direction="row" spacing={1}>
                  <div>
                    <svg
                      width="63"
                      height="63"
                      viewBox="0 0 63 63"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="31.5" cy="31.5" r="31.5" fill="#53B5E0" />
                      <path
                        d="M44.3162 23.0512L32.3162 19.0512C32.111 18.9828 31.889 18.9828 31.6838 19.0512L19.6837 23.0512C19.4846 23.1176 19.3114 23.2449 19.1887 23.4152C19.066 23.5855 19 23.7901 19 24V34C19 34.2652 19.1054 34.5195 19.2929 34.7071C19.4804 34.8946 19.7348 35 20 35C20.2652 35 20.5196 34.8946 20.7071 34.7071C20.8946 34.5195 21 34.2652 21 34V25.3875L25.1987 26.7862C24.0832 28.5885 23.7285 30.7598 24.2124 32.8233C24.6964 34.8869 25.9795 36.6741 27.78 37.7925C25.53 38.675 23.585 40.2712 22.1625 42.4537C22.0885 42.5637 22.0371 42.6872 22.0113 42.8172C21.9855 42.9472 21.9858 43.081 22.0122 43.2109C22.0385 43.3408 22.0905 43.4641 22.1649 43.5737C22.2394 43.6834 22.3349 43.7771 22.4459 43.8495C22.5569 43.9219 22.6812 43.9715 22.8115 43.9955C22.9419 44.0194 23.0757 44.0172 23.2051 43.989C23.3346 43.9608 23.4572 43.9071 23.5658 43.8311C23.6743 43.7551 23.7667 43.6582 23.8375 43.5462C25.7213 40.6562 28.6962 39 32 39C35.3037 39 38.2788 40.6562 40.1625 43.5462C40.3092 43.7642 40.5357 43.9157 40.7932 43.968C41.0507 44.0203 41.3184 43.9691 41.5385 43.8256C41.7586 43.682 41.9133 43.4576 41.9692 43.2009C42.0252 42.9442 41.9779 42.6758 41.8375 42.4537C40.415 40.2712 38.4625 38.675 36.22 37.7925C38.0188 36.6741 39.3007 34.8881 39.7846 32.8261C40.2684 30.764 39.9148 28.5942 38.8013 26.7925L44.3162 24.955C44.5154 24.8886 44.6886 24.7613 44.8114 24.591C44.9342 24.4207 45.0002 24.2161 45.0002 24.0062C45.0002 23.7963 44.9342 23.5917 44.8114 23.4214C44.6886 23.2511 44.5154 23.1238 44.3162 23.0575V23.0512ZM38 31C38.0003 31.9485 37.7756 32.8836 37.3445 33.7286C36.9134 34.5735 36.2881 35.3042 35.5199 35.8607C34.7517 36.4172 33.8625 36.7836 32.9253 36.9299C31.9881 37.0762 31.0295 36.9982 30.1283 36.7022C29.2271 36.4063 28.4088 35.901 27.7407 35.2276C27.0726 34.5542 26.5737 33.7321 26.2849 32.8285C25.9961 31.925 25.9256 30.9659 26.0792 30.0298C26.2329 29.0938 26.6063 28.2075 27.1687 27.4437L31.6838 28.9437C31.889 29.0121 32.111 29.0121 32.3162 28.9437L36.8312 27.4437C37.5909 28.4737 38.0005 29.7201 38 31ZM32 26.9462L23.1625 24L32 21.0537L40.8375 24L32 26.9462Z"
                        fill="white"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M44.517 22.9229V22.9071L32.3803 18.8615C32.1339 18.7794 31.8676 18.7794 31.6213 18.8615L19.6213 22.8615C19.3823 22.9412 19.1745 23.094 19.0273 23.2983C18.88 23.5027 18.8008 23.7481 18.8008 24C18.8008 24 18.8008 24 18.8008 24V34C18.8008 34.3183 18.9272 34.6235 19.1523 34.8485C19.3773 35.0736 19.6825 35.2 20.0008 35.2C20.319 35.2 20.6243 35.0736 20.8493 34.8485C21.0744 34.6235 21.2008 34.3183 21.2008 34V25.6649L24.9001 26.8973C23.8592 28.7005 23.5416 30.8358 24.0185 32.869C24.4852 34.8592 25.6771 36.5986 27.3537 37.7521C25.2136 38.6748 23.3655 40.2434 21.9965 42.3433C21.9082 42.475 21.8468 42.6228 21.8159 42.7783C21.785 42.9343 21.7853 43.0949 21.817 43.2507C21.8486 43.4066 21.9109 43.5546 22.0002 43.6862C22.0896 43.8177 22.2042 43.9302 22.3374 44.0171C22.4706 44.104 22.6197 44.1635 22.7762 44.1922C22.9326 44.221 23.0931 44.2183 23.2485 44.1845C23.4039 44.1506 23.551 44.0862 23.6813 43.995C23.8111 43.904 23.9217 43.7882 24.0066 43.6543C25.8554 40.8187 28.7685 39.2 32.0008 39.2C35.2335 39.2 38.147 40.8191 39.9957 43.6555L39.9973 43.6579C40.1733 43.9195 40.4452 44.1013 40.7542 44.164C41.0632 44.2268 41.3845 44.1654 41.6485 43.9931C41.9126 43.8209 42.0983 43.5516 42.1654 43.2436C42.2326 42.9355 42.1758 42.6134 42.0073 42.3469L42.0058 42.3445C40.6367 40.2439 38.7817 38.6751 36.6473 37.7523C38.3224 36.5989 39.5134 34.8606 39.9801 32.8718C40.4568 30.84 40.1404 28.7062 39.1013 26.9036L44.3803 25.1447C44.6192 25.0651 44.8271 24.9123 44.9744 24.708C45.1217 24.5037 45.201 24.2582 45.201 24.0063C45.201 23.7543 45.1217 23.5088 44.9744 23.3045C44.856 23.1402 44.6984 23.0093 44.517 22.9229ZM38.9075 26.9682C38.8732 26.9092 38.838 26.8507 38.802 26.7925L44.317 24.955C44.5162 24.8887 44.6894 24.7613 44.8122 24.591C44.9349 24.4208 45.001 24.2162 45.001 24.0063C45.001 23.7963 44.9349 23.5917 44.8122 23.4215C44.6894 23.2512 44.5162 23.1238 44.317 23.0575V23.0513L32.317 19.0513C32.1118 18.9828 31.8898 18.9828 31.6845 19.0513L19.6845 23.0513C19.4854 23.1176 19.3122 23.245 19.1895 23.4153C19.0668 23.5855 19.0008 23.7901 19.0008 24V34C19.0008 34.2652 19.1061 34.5196 19.2937 34.7071C19.4812 34.8946 19.7356 35 20.0008 35C20.266 35 20.5204 34.8946 20.7079 34.7071C20.8954 34.5196 21.0008 34.2652 21.0008 34V25.3875L25.1995 26.7863C25.1635 26.8444 25.1283 26.903 25.0939 26.9619C24.062 28.7285 23.7449 30.8264 24.2132 32.8234C24.6784 34.8071 25.8822 36.5354 27.5741 37.6597C27.6422 37.705 27.7111 37.7492 27.7808 37.7925C27.7044 37.8225 27.6284 37.8532 27.5528 37.8848C25.3994 38.784 23.5375 40.3453 22.1633 42.4538C22.0893 42.5637 22.0379 42.6873 22.0121 42.8173C21.9863 42.9472 21.9866 43.0811 22.013 43.2109C22.0393 43.3408 22.0912 43.4642 22.1657 43.5738C22.2402 43.6834 22.3357 43.7772 22.4467 43.8496C22.5577 43.922 22.6819 43.9716 22.8123 43.9955C22.9426 44.0195 23.0764 44.0173 23.2059 43.989C23.3354 43.9608 23.458 43.9071 23.5666 43.8311C23.6751 43.7551 23.7675 43.6583 23.8383 43.5463C25.722 40.6563 28.697 39 32.0008 39C35.3045 39 38.2795 40.6563 40.1633 43.5463C40.31 43.7642 40.5365 43.9158 40.794 43.968C41.0515 44.0203 41.3192 43.9691 41.5393 43.8256C41.7593 43.6821 41.9141 43.4577 41.97 43.201C42.026 42.9443 41.9787 42.6758 41.8383 42.4538C40.4641 40.3454 38.5954 38.7842 36.4484 37.885C36.3729 37.8533 36.297 37.8225 36.2208 37.7925C36.2904 37.7492 36.3592 37.705 36.4272 37.6598C38.1175 36.5356 39.3202 34.8084 39.7853 32.8261C40.2536 30.8306 39.9376 28.7342 38.9075 26.9682ZM37.8008 30.9999C37.8013 29.8111 37.4356 28.6521 36.7555 27.6799L32.3803 29.1335C32.1339 29.2156 31.8676 29.2156 31.6213 29.1335L27.2462 27.68C26.7494 28.3911 26.4181 29.2051 26.2774 30.0623C26.1288 30.9671 26.197 31.8943 26.4762 32.7677C26.7554 33.6411 27.2377 34.4359 27.8835 35.0868C28.5293 35.7377 29.3203 36.2262 30.1915 36.5123C31.0627 36.7983 31.9893 36.8737 32.8953 36.7323C33.8012 36.5909 34.6608 36.2367 35.4034 35.6988C36.1459 35.1608 36.7504 34.4545 37.1672 33.6377C37.5839 32.821 37.801 31.9169 37.8008 30.9999ZM27.1695 27.4438C26.607 28.2075 26.2337 29.0938 26.08 30.0299C25.9264 30.9659 25.9968 31.925 26.2857 32.8286C26.5745 33.7321 27.0734 34.5543 27.7415 35.2277C28.4096 35.901 29.2279 36.4064 30.1291 36.7023C31.0303 36.9982 31.9889 37.0762 32.9261 36.9299C33.8633 36.7836 34.7525 36.4172 35.5207 35.8607C36.2889 35.3043 36.9142 34.5736 37.3453 33.7286C37.7764 32.8837 38.0011 31.9486 38.0008 31C38.0013 29.7201 37.5917 28.4738 36.832 27.4438L32.317 28.9438C32.1118 29.0122 31.8898 29.0122 31.6845 28.9438L27.1695 27.4438ZM32.0008 26.7354L40.2059 24L32.0008 21.2646L23.7957 24L32.0008 26.7354ZM32.0008 26.9463L40.8383 24L32.0008 21.0538L23.1633 24L32.0008 26.9463Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div>
                    <h3>{'Students'}</h3>
                    <div className="total-participant">
                      Total Participants:{' '}
                      <span>
                        {showLoadCount ? <CircularProgress size={20} /> : count}
                      </span>
                    </div>
                    <div className="show-participant" onClick={handleOpen}>
                      Show Participants
                    </div>
                  </div>
                </Stack>
              </div>
              <div></div>
            </Stack>
          </Grid>
        </Grid>
      </div>
      {open && (
        <WbModal
          onClose={e => setOpen(false)}
          title={'Participants'}
          content={
            loading ? (
              <>
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
              </>
            ) : (
              <ParticipantList list={pList} type={'Students'} />
            )
          }
        ></WbModal>
      )}
    </div>
  )
}
